import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { noop } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CloseIcon } from '../../../../resources/assets/components/DLS_Cross.svg';
import './modal-close.css';
function ModalClose(props) {
    const { onClick = noop } = props;
    return (React.createElement("div", { className: "c-modal-close" },
        React.createElement(CloseIcon, { "aria-label": MessageService.translate('tws.modal.close-icon-aria-label'), className: "c-modal-close__icon", onClick: onClick })));
}
export { ModalClose, };
//# sourceMappingURL=modal-close.js.map